import { createContext } from "react";
import { Timezone } from "../components-v2/common/layout/Layout";
import { IGlobalDateFilter } from "../models/filters/IFilters";

export interface StaticGlobalFilterContextType {
  timezone: Timezone;
  globalStaticFilterDate: IGlobalDateFilter;
}

export const StaticGlobalFilterContext =
  createContext<StaticGlobalFilterContextType>({
    timezone: "LT",
    globalStaticFilterDate: { startDate: new Date(), endDate: new Date() },
  });
